import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateTimeRange from '../../UserControl/DateTimeRange/DateTimeRange';

const user_id="1";
const user_name="toto";
const token ="admin";
class PetroleumSetting extends Component {

    constructor() {
        super();

        this.state  = {
            selectDateRange:[],
        };
    }
    componentDidMount(){
        
    }
    componentWillUnmount(){
        
    }

    setRangeDate(sDate,eDate){
        // startDate=sDate;
        // endDate=eDate;
        // if(sDate && eDate && sDate!=null && eDate!=null){
        //     startDate=sDate.toObject();
        //     endDate=eDate.toObject();
        // }
        console.log("setRangeDate");
    }

    render(){
       

        return(
        
        <div className="container-fluid">
        <div className="card">
                <h5 className="card-header">ตั้งค่าน้ำมัน</h5>
                <div className="card-body">
                    <div className="col-md-12">
                    <DateTimeRange onSelectDate={this.setRangeDate.bind(this)}
                                   />
                    </div>      
                </div>
            </div>
           
        </div>
            
        );
    }
}

export default PetroleumSetting;


// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/PetroleumSetting.js